import DSIF from 'constants/time/dsif.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

const isValidIsoFormat = (value) => {
  const trimmed = fromAnyToTrimmed(value);

  if (!trimmed) return false;

  // this removes all non-strings from being recognized as properly formatted ones
  if (value !== trimmed) return false;

  return fromAnyToBool(trimmed.match(DSIF.iso));
};

export default isValidIsoFormat;
